// Configuration file for frontend application
// This allows easy configuration of backend URL for different environments

const config = {
  // Backend API URL - Change this to your backend server URL
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://restaurant-billing-api.onrender.com/api',
  
  // Backend Auth URL (for direct fetch calls)
  AUTH_BASE_URL: (process.env.REACT_APP_API_URL || 'https://restaurant-billing-api.onrender.com/api').replace('/api', ''),
  
  // API timeout in milliseconds
  API_TIMEOUT: 10000,
};

export default config;
